import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { factory, Group, useProps } from '@coveord/plasma-mantine';
import { Children } from 'react';
import { useEmptyStateContext } from './EmptyStateContext.js';
var defaultProps = {
    gap: 'sm'
};
export var EmptyStateActions = factory(function(_props, ref) {
    var ctx = useEmptyStateContext();
    var _useProps = useProps('EmptyStateActions', defaultProps, _props), children = _useProps.children, others = _object_without_properties(_useProps, [
        "children"
    ]);
    var actionsCount = Children.count(children);
    return actionsCount > 0 ? /*#__PURE__*/ _jsx(Group, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        ref: ref
    }, ctx.getStyles('actionsContainer')), {
        justify: ctx.variant === 'small' ? 'center' : 'flex-start'
    }), others), {
        children: children
    })) : null;
});

//# sourceMappingURL=EmptyStateActions.js.map